const { createSlice } = require("@reduxjs/toolkit");

const flagSlice = createSlice({
  name: "flag",
  initialState: { flag: false, data: null, isSidebarOpen: false },
  reducers: {
    flagTrue(state, action) {
      const { payload } = action;
      return { flag: true, data: payload };
    },
    flagFalse(state, action) {
      const { payload } = action;
      return { flag: false, data: payload };
    },
    sidebarOpen(state, action) {
      const { payload } = action;
      return { ...state, isSidebarOpen: payload };
    },
  },
});

export const { flagTrue, flagFalse, sidebarOpen } = flagSlice.actions;
export default flagSlice.reducer;
